import { z } from 'zod';

// schema for the form values used in NoteModal
export const noteFormSchema = z.object({
    note: z.string().min(1, "Note is required"),
    isPublic: z.boolean(),
});

export type NoteForm = z.infer<typeof noteFormSchema>;
